module.exports = __webpack_public_path__ + "5465b998c6aa02d73bff468f9e0b27e3.pdf";